import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../hooks/validation-group/validation-group-hook';
import AdyenBasicCredentialsStore from '../../../stores/credentials/adyen-basic-credentials-store';

interface IIntegrationProps {
    credentialsStore: AdyenBasicCredentialsStore,
    vGroup: IValidationGroup,
}

const AdyenBasicCredentials: React.FC<IIntegrationProps> = observer(({credentialsStore, vGroup}) => {
    return (
        <>
            <FormFieldLine 
                label='Merchant ID'
                note='Your Adyen merchant ID'
                required
                key='merchant_id'
            >
                <Input
                    value={credentialsStore.merchant_id}
                    placeholder=''
                    onChange={v => credentialsStore.merchant_id = v}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine 
                label='Live URL Prefix'
                note='Your Adyen live URL prefix. Required for live environment'
                key='live_prefix'
            >
                <Input
                    value={credentialsStore.live_prefix}
                    placeholder=''
                    onChange={v => credentialsStore.live_prefix = v}
                    validationGroup={vGroup}
                    required={!credentialsStore.isSandbox}
                />
            </FormFieldLine>
            <FormFieldLine 
                label='API Key'
                note='Your Adyen API key'
                required
                key='api_key'
            >
                <Input
                    value={credentialsStore.api_key}
                    placeholder=''
                    onChange={v => credentialsStore.api_key = v}
                    validationGroup={vGroup}
                    type='password'
                    autoComplete='new-password'
                    required
                />
            </FormFieldLine>
        </>
    )
});

export default AdyenBasicCredentials; 